import configure from '../configure'
import Vue from 'vue'
import VueResource from 'vue-resource'

Vue.use(VueResource)

export default class Player {
  get (id) {
    Vue.http.get(configure.api_url + 'registrations/' + id).then(response => {
      return response
    })
  }

  playersReady (players) {
    let ready = []
    players.forEach((player) => {
      player.cards.forEach((card) => {
        if (ready[card.date_id] === undefined) {
          ready[card.date_id] = []
        }
        ready[card.date_id].push(player)
      })
    })
    return ready
  }

  playersWaiting (dateId, playersReady, players) {
    let waiting = []
    players.forEach((player) => {
      let index = playersReady[dateId].indexOf(player)
      if (index === -1 && player.status >= 3) {
        waiting.push(player)
      }
    })
    return waiting
  }

  update (player) {
    return Vue.http.put(
      configure.api_url + 'registrations/' + player.id,
      player
    ).then(response => {
      return response
    })
  }

  attach (id, team) {
    return Vue.http.post(
      configure.api_url + 'registrations/' + id + '/team',
      {team: team}
    ).then(response => {
      return response
    })
  }

  detach (id, team) {
    return Vue.http.put(
      configure.api_url + 'registrations/' + id + '/team',
      {team: team}
    ).then(response => {
      return response
    })
  }
}



/** WEBPACK FOOTER **
 ** ./src/api/player.js
 **/